export const periodShowInCutaway = [
  {
    dataKey: 'upTo10DaysPlan',
    fill: '#2f81edb9',
    name: 'До 10 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'upTo10DaysFact',
    fill: '#2F80ED',
    name: 'До 10 дней (Факт)',
    status: 'Факт',
  },
  {
    dataKey: 'from10To45DaysPlan',
    fill: '#f2984aba',
    name: 'с 10 до 45 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'from10To45DaysFact',
    fill: '#F2994A',
    name: 'с 10 до 45 дней (Факт)',
    status: 'Факт',
  },
  {
    dataKey: 'over45DaysPlan',
    fill: '#eb5757b5',
    name: 'Свыше 45 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'over45DaysFact',
    fill: '#EB5757',
    name: 'Свыше 45 дней (Факт)',
    status: 'Факт',
  }
]

export const periodShowInCutawayWithClosed = [
  {
    dataKey: 'upTo10DaysPlan',
    fill: '#2f81edb9',
    name: 'До 10 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'upTo10DaysClosed',
    fill: '#2F80ED',
    name: 'До 10 дней (Закрытые)',
    status: 'Факт',
  },
  {
    dataKey: 'from10To45DaysPlan',
    fill: '#f2984aba',
    name: 'с 10 до 45 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'from10To45DaysClosed',
    fill: '#F2994A',
    name: 'с 10 до 45 дней (Закрытые)',
    status: 'Факт',
  },
  {
    dataKey: 'over45DaysPlan',
    fill: '#eb5757b5',
    name: 'Свыше 45 дней (План)',
    status: 'План',
  },
  {
    dataKey: 'over45DaysClosed',
    fill: '#EB5757',
    name: 'Свыше 45 дней (Закрытые)',
    status: 'Факт',
  }
]

export const periodWithClosed = [
  {
    dataKey: 'upTo10DaysClosed',
    fill: '#2F80ED',
    name: 'До 10 дней (Закрытые)',
  },
  {
    dataKey: 'from10To45DaysClosed',
    fill: '#F2994A',
    name: 'с 10 до 45 дней (Закрытые)',
  },
  {
    dataKey: 'over45DaysClosed',
    fill: '#EB5757',
    name: 'Свыше 45 дней (Закрытые)',
  }
]

export const periodFact = [
  {
    dataKey: 'upTo10DaysFact',
    fill: '#2F80ED',
    name: 'До 10 дней (Факт)',
  },
  {
    dataKey: 'from10To45DaysFact',
    fill: '#F2994A',
    name: 'с 10 до 45 дней (Факт)',
  },
  {
    dataKey: 'over45DaysFact',
    fill: '#EB5757',
    name: 'Свыше 45 дней (Факт)',
  }
]

export const completeShowInCutaway = [
  {
    dataKey: 'plan',
    fill: '#27ae5f8d',
    name: '(План)',
    status: 'План'
  },
  {
    dataKey: 'fact',
    fill: '#27AE60',
    name: '(Факт)',
    status: 'Факт'
  },
]

export const completeShowInCutawayWithClosed = [
  {
    dataKey: 'plan',
    fill: '#27ae5f8d',
    name: '(План)',
    status: 'План'
  },
  {
    dataKey: 'closed',
    fill: '#27AE60',
    name: '(Зарытые)',
    status: 'Факт'
  },
]